import {
  BadgePercent,
  GraduationCap,
  CreditCard,
  CircleCheck,
  ChevronRight,
} from "lucide-react";

import Accordion from "./Accordion";

function EnLineaPagos() {
  return (
    <>
      {
        <section
          id="descuentos"
          className="relative overflow-hidden rounded-3xl border border-[#f1f5f9] bg-white p-6 md:p-10 shadow-xl"
        >
          <div className="relative z-10">
            {/* Header */}
            <div className="mb-8 flex items-start gap-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#f1f5f9] text-[#004270] shadow-sm">
                <BadgePercent className="h-8 w-8" />
              </div>

              <div>
                <span className="mb-2 inline-flex rounded-full bg-[#febe10] px-3 py-1 text-xs font-bold uppercase tracking-wide text-[#004270]">
                  Beneficios económicos
                </span>

                <h2 className="text-3xl font-bold font-montserrat leading-tight text-[#004270]">
                  Obtén hasta un{" "}
                  <span className="text-[#febe10]">45% de descuento</span> en tu
                  matrícula
                </h2>

                <p className="m-0 p-0 text-[#64748b]">
                  Aprovecha descuentos, becas y facilidades de pago para iniciar
                  tus estudios en la UTPL.
                </p>
              </div>
            </div>

            {/* GRID */}
            <div className="grid gap-6 lg:grid-cols-2">
              {/* DESCUENTOS */}
              <div className="rounded-2xl border border-[#f1f5f9] bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div className="mb-5 flex items-center gap-3">
                  <div className="rounded-xl bg-[#f1f5f9] p-3 text-[#004270]">
                    <BadgePercent className="h-6 w-6" />
                  </div>

                  <h3 className="m-0 text-2xl font-bold text-[#004270]">
                    Descuentos
                  </h3>
                </div>

                <div className="space-y-5">
                  <div className="flex gap-3">
                    <CircleCheck className="mt-1 h-5 w-5 text-[#febe10]" />

                    <p className="m-0 leading-7 text-[#64748b]">
                      <b>14% de descuento</b> hasta el{" "}
                      <b>17 de agosto de 2026</b>.
                    </p>
                  </div>

                  <div className="flex gap-3">
                    <CircleCheck className="mt-1 h-5 w-5 text-[#febe10]" />

                    <p className="m-0 leading-7 text-[#64748b]">
                      <b>10% de descuento adicional</b> si eres{" "}
                      <b>UTPL Alumni</b>.
                    </p>
                  </div>
                </div>
              </div>

              {/* BECAS */}
              <div className="rounded-2xl border border-[#f1f5f9] bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
                <div className="mb-5 flex items-center gap-3">
                  <div className="rounded-xl bg-[#f1f5f9] p-3 text-[#004270]">
                    <GraduationCap className="h-6 w-6" />
                  </div>

                  <h3 className="m-0 text-2xl font-bold text-[#004270]">
                    Becas
                  </h3>
                </div>

                <div className="space-y-5">
                  <div className="flex gap-3">
                    <CircleCheck className="mt-1 h-5 w-5 text-[#febe10]" />

                    <div>
                      <p className="m-0 leading-7 text-[#64748b]">
                        <b>10% de descuento adicional</b> por Beca Convenio.
                      </p>
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <CircleCheck className="mt-1 h-5 w-5 text-[#febe10]" />

                    <div>
                      <p className="m-0 leading-7 text-[#64748b]">
                        Descubre más opciones de becas diseñadas para ti.
                      </p>

                      <a
                        href="https://becas.utpl.edu.ec"
                        target="_blank"
                        rel="noreferrer"
                        className="mt-2 inline-flex items-center gap-2 font-semibold text-[#004270] transition hover:text-[#febe10]"
                      >
                        Conocer becas
                        <ChevronRight className="h-4 w-4" />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* FINANCIAMIENTO */}
            <div className="mt-6 rounded-3xl bg-[#004270] p-8 text-white shadow-2xl">
              <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
                <div className="max-w-2xl">
                  <div className="mb-4 inline-flex rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-[#febe10]">
                    Opciones de financiamiento
                  </div>

                  <div className="flex items-center gap-3">
                    <CreditCard className="h-8 w-8 text-[#febe10]" />

                    <h3 className="m-0 p-0  font-bold text-white">
                      Difiere tu matrícula hasta 12 meses sin intereses
                    </h3>
                  </div>

                  <div className="mt-6">
                    <div className="flex items-center gap-3">
                      <CircleCheck className="h-5 w-5 text-[#febe10]" />

                      <p className="m-0 text-white">
                        Disponible con tarjetas de crédito participantes.
                      </p>
                    </div>
                  </div>
                </div>

                <a
                  href="https://utpl.edu.ec/documentos/opcionespago.pdf"
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#febe10] px-6 py-4 font-bold text-[#004270] transition-all hover:bg-[#e0a609]  hover:text-[#004270]"
                >
                  Ver opciones de pago
                  <ChevronRight className="h-5 w-5" />
                </a>
              </div>
            </div>

            {/* ACCORDIONS */}
            <div className="mt-8 space-y-4">
              <div className="rounded-2xl border border-[#f1f5f9] bg-white p-6 shadow-sm">
                <Accordion
                  title="Otros descuentos"
                  content={
                    <div className="space-y-4 text-[#64748b]">
                      <div className="flex gap-3">
                        <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />

                        <p className="m-0">
                          <b>50% de descuento</b> por reingreso. No se combina
                          con otras becas ni descuentos.
                        </p>
                      </div>
                    </div>
                  }
                />
              </div>

              <div className="rounded-2xl border border-[#f1f5f9] bg-white p-6 shadow-sm">
                <Accordion
                  title="Plan de pagos"
                  content={
                    <div className="space-y-5 text-[#64748b]">
                      <p className="rounded-xl border border-[#f1f5f9] bg-[#f1f5f9] p-4 text-[#004270]">
                        <b>
                          Si eliges un plan de pagos, no aplica el descuento por
                          forma de pago.
                        </b>
                      </p>

                      <div className="space-y-3">
                        <div className="flex gap-3">
                          <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />

                          <p className="m-0">
                            Paga 50% al matricularte y 50% hasta el 2 de junio
                            de 2026.
                          </p>
                        </div>

                        <div className="flex gap-3">
                          <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />

                          <p className="m-0">
                            Paga 40% al matricularte, 30% hasta el 15 de mayo de
                            2026 y 30% hasta el 1 de julio de 2026.
                          </p>
                        </div>
                      </div>
                    </div>
                  }
                />
              </div>
            </div>
          </div>
        </section>
      }
    </>
  );
}

export default EnLineaPagos;
